import React from 'react';
import type { StatusTransition } from '../../../../common/types.tsx';
import { StatusLozenge } from '../../../../common/ui/status-lozenge/index.tsx';

type Props = {
	isDisabled?: boolean;
	transition: StatusTransition;
};

export const TransitionWithoutLabel = (props: Props): React.JSX.Element => (
	<StatusLozenge status={props.transition.to} isDisabled={props.isDisabled} />
);
